export const PLATFORM_ROLES = [
  "platform_admin",
  "billing_admin",
  "account_manager",
  "support",
] as const;

export type PlatformRole = (typeof PLATFORM_ROLES)[number];

export const [
  PLATFORM_ADMIN_ROLE,
  BILLING_ADMIN_ROLE,
  ACCOUNT_MANAGER_ROLE,
  SUPPORT_ROLE,
] = PLATFORM_ROLES;
